module.exports = __webpack_public_path__ + "img/icon-ppls.9d3bd10c.png";